<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/18vGHZT/tc-custom/9781607059707.jpg?1694212735457" alt="This image is the cover for the book Wool Appliqué Folk Art"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Wool Appliqué Folk Art
      </h1>
      <p class="bookDescription body article font2">
        <b>14 folk-art projects that celebrate American heritage with wool appliqué.</b><br/><br/>Savor the richness and beauty of wool appliqué—its texture, depth, color, and design. Well-known, award-winning folk artist Rebekah L. Smith will ignite your passion for Americana home decor with her simple and elegant designs. Hand stitch 14 folk-art projects, each with full-size patterns and step-by-step instructions. Appliqué pillows, bed toppers, and table runners from woven wools, felted wools, and wool felt—upcycling at its finest! Staying true to early decorative arts, the antique color palette and nature-inspired designs translate seamlessly to many modern living spaces.<br/><br/>• 14 wool felt appliqué projects include bed covers, wall hangings, and table runners<br/><br/>• A guide for beginners, seasoned stitchers, traditional quilters, embroiderers, textile artisans, and general crafters<br/><br/>• Instructions on finding and repurposing wool<br/><br/><b>Praise for <i>Wool Appliqué Folk Art</i></b><br/><br/><b>“I particularly liked the 14 updated traditional projects in Rebekah's book, which included bed covers, wall hangings and table runners. Her designs are very appealing. There is something in this book for everyone, from beginner to seasoned stitcher.” —<i>The Canadian Quilter</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rebekah L. Smith
      </h2>
      
      <p class="authorDescription body article">Rebekah L Smith Bio: Rebekah L. Smith studied graphic design at the Art Institute of Pittsburgh and specializes in wool work, murals, and American folk art. Rebekah and her husband, along with their three daughters, continually work to restore an 1838 house in Ohio. rebekahlsmith.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      C&T Publishing, Inc
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?12837326